import React, { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UserManagementLayout from './Layout';
import UsersPage from './pages/UsersPage';
import OrganizationsPage from './pages/OrganizationsPage';
import UserDetailsPage from './pages/UserDetailsPage';

import { MinimizedDrawersProvider } from './context/MinimizedDrawersProvider';
import { MinimizedDisplayArea } from './components/MinimizedDisplayArea';
import { UserManagementContextProvider } from './context/UserManagementContext';
import { Page } from '@backstage/core-components';
import { useTemplates, useOrganizations } from './hooks';
import { mapTemplate } from './utils';
import { ApiError } from '../../shared/api/apiService';
import { CustomErrorPage } from '../CustomErrorPage';

const RedirectToUsers = () => {
  return <Navigate to="users" replace />;
};

const UserManagementContent = () => {
  const { data: templates, isError, error } = useTemplates();
  const { data: organizations } = useOrganizations();
  const mappedTemplates = useMemo(() => {
    return mapTemplate(templates);
  }, [templates]);

  if (isError) {
    const status =
      error instanceof ApiError && error.status === 403 ? '403' : '500';
    return (
      <CustomErrorPage
        status={status}
        statusMessage={status === '403' ? 'Forbidden' : 'Something went wrong'}
      />
    );
  }

  return (
    <UserManagementContextProvider
      initState={{
        templates: mappedTemplates,
        organizations,
      }}
    >
      <Page themeId="userManagementTheme">
        <Routes>
          <Route path="/" element={<UserManagementLayout />}>
            <Route index element={<RedirectToUsers />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="teams" element={<OrganizationsPage />} />
            <Route path="users/:id" element={<UserDetailsPage />} />
          </Route>
        </Routes>
      </Page>
    </UserManagementContextProvider>
  );
};

export default function UserManagement() {
  return (
    <MinimizedDrawersProvider>
      <UserManagementContent />
      <MinimizedDisplayArea />
    </MinimizedDrawersProvider>
  );
}
